export const getRandomizedLoadingCaption = (): string => {
  const captionLoadingPlaceholders = [
    window.i18next.t('pmwjs_sm_publishing_caption_loading_1'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_2'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_3'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_4'),
    window.i18next.t('pmwjs_sm_publishing_caption_loading_5'),
  ];

  const randomNumber = Math.floor(Math.random() * 5);
  return captionLoadingPlaceholders[randomNumber];
};

export const CAPTION_TAGS_POPOVER_ALREADY_SHOWN = 'tags_popover_already_shown';

export const USER_HAS_SEEN_MAX_TAGS_POPOVERS = 'user_has_seen_max_tags_popovers';